module.exports = __webpack_public_path__ + "img/notebook-pen-red.433d11dd.svg";